export const getPrefecturesSuccess = (listPrefectures = []) => {
    return {
      type : 'GET_PREFECTURES_SUCCESS',
      payload: listPrefectures 
    }
  };
  